module.exports = __webpack_public_path__ + "static/media/Macbook1.01945ae8.png";